module.exports = "/images/menu-language.svg?86b08f522ffa386618346fddc092a78a";